<template>
  <div>
    <d-card-row>
      <v-input
        v-model="form.address_1"
        name="address_1"
      />
      <v-input
        v-model="form.address_2"
        name="address_2"
      />
      <v-input
        v-model="form.city"
        name="city"
      />
      <d-input-group>
        <v-input-select
          v-model="form.state"
          name="state"
          class="column"
        >
          <option
            v-for="region in $laravel.regions"
            :key="region.code"
            :value="region.code"
          >
            {{ region.name }}
          </option>
        </v-input-select>
        <v-input-select
          v-model="form.country"
          name="country"
          class="column"
          disabled
        >
          <option
            v-for="country in $laravel.countries"
            :key="country.code_2"
            :value="country.code_2"
          >
            {{ country.name }}
          </option>
        </v-input-select>
      </d-input-group>
      <v-input-cleave
        v-model="form.postal_code"
        name="postal_code"
        :mask="masks.postalCode"
      />
    </d-card-row>

    <d-card-row>
      <d-input-group>
        <v-input-phone
          v-model="form.phone"
          name="phone"
          class="is-flex-grow-1"
        />
        <v-input
          v-model="form.phone_extension"
          name="phone_extension"
        />
      </d-input-group>
      <d-input-group>
        <v-input-phone
          v-model="form.cell_phone"
          name="cell_phone"
          class="is-flex-grow-1"
        />
      </d-input-group>
    </d-card-row>

    <d-card-row>
      <v-input-date
        v-model="form.birthday"
        name="birthday"
        position="is-top-right"
      />
    </d-card-row>

    <d-card-row v-if="$scopedSlots.footer">
      <slot
        name="footer"
      />
    </d-card-row>
  </div>
</template>

<script>
import Fieldset from "@/plugins/form/Fieldset";
import masks from "@/services/masks";

export default {
  extends: Fieldset,
  data () {
    return {
      masks: masks
    };
  }
};

</script>
